var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIcoKids = function SvgIcoKids(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 20,
    fill: "none",
    viewBox: "0 0 22 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#EEE",
    fillRule: "evenodd",
    d: "M6 6a3 3 0 1 0 0-6 3 3 0 0 0 0 6m0 1C3.41 7 1.412 8.2.126 10.514a1 1 0 0 0 1.748.972q.487-.878 1.126-1.44V19a1 1 0 1 0 2 0v-3h2v3a1 1 0 1 0 2 0v-8.955q.632.557 1.116 1.424l.017.032c.57.986 1.294 1.873 2.272 2.51q.285.186.594.338V19a1 1 0 1 0 2 0v-1h2v1a1 1 0 1 0 2 0v-4.65c.83-.412 1.521-1.002 2.1-1.724a1 1 0 0 0-1.558-1.252c-.804 1-1.858 1.626-3.543 1.626-1.078 0-1.875-.257-2.502-.666-.633-.412-1.158-1.02-1.622-1.819C10.586 8.2 8.587 7 6 7m0 2h.048-.097zm11.998 1a2 2 0 1 1-4 0 2 2 0 0 1 4 0",
    clipRule: "evenodd"
  })));
};
export default SvgIcoKids;